'use client';

export { default } from './Dialog';
export { default as dialogClasses } from './dialogClasses';
export * from './dialogClasses';


//////////////////
// WEBPACK FOOTER
// ../@mui/material/Dialog/index.js
// module id = 915
// module chunks = 25